import * as tslib_1 from "tslib";
import { BaseComponent } from "./BaseComponent";
import { IntrinsicComponent } from "./IntrinsicComponent";
import { getMetadata } from "../metadata/Metadata";
var Component = /** @class */ (function (_super) {
    tslib_1.__extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Component.prototype.build = function (childNodes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hostElement;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.build.call(this, childNodes)];
                    case 1:
                        hostElement = _a.sent();
                        this.resolveElementRefs();
                        this.bindToEvents();
                        return [2 /*return*/, hostElement];
                }
            });
        });
    };
    Component.prototype.destroy = function () {
        if (this.destroyed)
            return;
        this.unbindFromEvents();
        _super.prototype.destroy.call(this);
    };
    Component.prototype.getEventNameSpace = function () {
        return "component_" + this.getComponentId();
    };
    Component.prototype.bindToEvents = function () {
        var metadata = getMetadata(this, 'EventListener');
        if (!metadata)
            return;
        for (var _i = 0, metadata_1 = metadata; _i < metadata_1.length; _i++) {
            var listenerMetadata = metadata_1[_i];
            var fullEventName = listenerMetadata.eventName + "." + this.getEventNameSpace();
            if (listenerMetadata.selector) {
                if (typeof listenerMetadata.selector === "string") {
                    this.getHostElement().on(fullEventName, listenerMetadata.selector, this.getMember(listenerMetadata.handler).bind(this));
                }
                else {
                    $(listenerMetadata.selector).on(fullEventName, this.getMember(listenerMetadata.handler).bind(this));
                }
            }
            else {
                this.getHostElement().on(fullEventName, this.getMember(listenerMetadata.handler).bind(this));
            }
        }
    };
    Component.prototype.getMember = function (name) {
        return this[name];
    };
    Component.prototype.resolveElementRefs = function () {
        var metadata = getMetadata(this, 'ElementReference');
        if (!metadata)
            return;
        for (var _i = 0, metadata_2 = metadata; _i < metadata_2.length; _i++) {
            var reference = metadata_2[_i];
            this[reference.handler] = this.getHostElement().find(reference.selector);
        }
    };
    Component.prototype.unbindFromEvents = function () {
        this.getHostElement().off("." + this.getEventNameSpace());
        var metadata = getMetadata(this, 'EventListener');
        if (!metadata)
            return;
        for (var _i = 0, metadata_3 = metadata; _i < metadata_3.length; _i++) {
            var listenerMetadata = metadata_3[_i];
            if (listenerMetadata.selector) {
                $(listenerMetadata.selector).off("." + this.getEventNameSpace());
            }
        }
    };
    Component.render = function (node, options) {
        var childNodes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            childNodes[_i - 2] = arguments[_i];
        }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var component, hostElement;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        component = typeof node === "string"
                            ? new IntrinsicComponent(node, options)
                            : new node(options);
                        return [4 /*yield*/, component.build(childNodes)];
                    case 1:
                        hostElement = _a.sent();
                        Component.renderedComponents.push(component);
                        return [2 /*return*/, hostElement];
                }
            });
        });
    };
    Component.mount = function (component, container, replaceContainer, clearContent) {
        if (replaceContainer === void 0) { replaceContainer = true; }
        if (clearContent === void 0) { clearContent = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var content;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, component];
                    case 1:
                        content = _a.sent();
                        if (replaceContainer) {
                            container.replaceWith(content);
                        }
                        else {
                            if (clearContent) {
                                container.empty();
                            }
                            container.append(content);
                        }
                        setTimeout(function () {
                            Component.mountRenderedComponents();
                        });
                        return [2 /*return*/, content];
                }
            });
        });
    };
    Component.mountRenderedComponents = function () {
        Component.renderedComponents.forEach(function (component) { return component.onMount && component.onMount(); });
        Component.renderedComponents = [];
    };
    Component.renderedComponents = [];
    return Component;
}(BaseComponent));
export { Component };
//# sourceMappingURL=Component.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/components/Component.js
// module id = 7
// module chunks = 1